import { number, route } from "react-router-typesafe-routes";

export const gigSidebarRouteParams = route({
  searchParams: {
    selected_gig_id: number(),
    selected_pro_id: number(),
  },
});
